import axios from 'axios';
import _ from 'lodash';

async function getSuppliersFromServer({ accesstoken, organizationId, me, onProgress }) {

    // Open the database
    const db = await new Promise((res, rej) => {
        const request = indexedDB.open(`${organizationId}-${me.email}-suppliers`, 1);
        request.onerror = (event) => {
            console.error('Why didn\'t you allow my web app to use IndexedDB?!', event);
            rej(event.target.error);
        };
        request.onsuccess = (event) => {
            console.log('[Suppliers: getSuppliersFromServer] Database opened successfully.');
            res(event.target.result);
        };
        request.onupgradeneeded = (event) => {
            console.log('[Suppliers: getSuppliersFromServer] Database onupgradeneeded called.');
            const db = event.target.result;
            db.createObjectStore('suppliers', { keyPath: 'id' });
        };
    });

    // Get existing opportunities from IndexedDB
    let cache = await new Promise((res, rej) => {
        console.log('[Suppliers: getSuppliersFromServer] Reading from IndexedDB.');
        const transaction = db.transaction(['suppliers'], 'readonly');
        const store = transaction.objectStore('suppliers');
        const request = store.getAll();
        request.onsuccess = (event) => {
            console.log('[Suppliers: getSuppliersFromServer] Done reading', event.target.result.length, 'from IndexedDB.');
            res(event.target.result);
        };
        request.onerror = (event) => {
            rej(event.target.error);
        }
    });


    const items = [];
    let cursor = null;
    const latest = (_.max(cache.map(r => parseInt(r.modified))) || 0) + 1;
    let shouldResetLocalDB = false;
    console.log(`[Suppliers: getSuppliersFromServer] Starting /api/suppliers?organizationId=${organizationId}&since=${latest}`);
    do {
        const { data } = await axios(`/api/suppliers?organizationId=${organizationId}&accesstoken=${accesstoken}&since=${latest}&cursor=${cursor ? cursor : ''}`);
        if (_.isArray(data)) return data;
        cursor = data.cursor;
        shouldResetLocalDB = data.shouldResetLocalDB;
        items.push(...data.suppliers);
        if (onProgress) onProgress({ total: data.count, count: items.length });
        console.log(`[Suppliers: getSuppliersFromServer] Read ${items.length} items. Has more? ${cursor ? 'Yes' : 'No'}`);
    } while (cursor);

    // Clear IndexexDB if requested
    if (shouldResetLocalDB) {
        console.log('[Suppliers: getSuppliersFromServer] Reset requested.');

        // Clear IndexedDB
        const transaction = db.transaction(['suppliers'], 'readwrite');
        const store = transaction.objectStore('suppliers');
        try {
            await new Promise((res, rej) => {
                const request = store.clear();
                request.onsuccess = (event) => {
                    console.log('[Suppliers: getSuppliersFromServer] IndexedDB cleared.');
                    res();
                };
                request.onerror = (event) => {
                    console.error('[Suppliers: getSuppliersFromServer] Error clearing IndexedDB.', event.target.error);
                    rej(event.target.error);
                }
            });
        } catch (e) { }
    }

    const transaction = db.transaction(['suppliers'], 'readwrite');
    const store = transaction.objectStore('suppliers');
    console.log('[Suppliers: getSuppliersFromServer] Adding', items.length, 'suppliers to IndexedDB.');
    for (let i = 0; i < items.length; i++) {
        const r = items[i];
        try {
            await new Promise((res, rej) => {
                const request = store.put(r); // TODO: Check if exists and update
                request.onsuccess = (event) => {
                    res();
                };
                request.onerror = (event) => {
                    rej(event.target.error);
                }
            });
        } catch (e) { }
    }

    console.log('[Suppliers: getSuppliersFromServer] Done adding', items.length, 'suppliers to IndexedDB.');
    if (shouldResetLocalDB) {
        return items.filter(r => r.id !== `${organizationId}-reset`);

    } else {
        return _.uniqBy([...items, ...cache], 'id').filter(r => r.id !== `${organizationId}-reset`);
    }
}

export { getSuppliersFromServer };